// Types
import { labelSchema, labelListSchema } from 'modules/labels/models'

// Utils
import { parseQueryForSearch } from 'modules/browse/actions'

export const actions = {
  fetchLabelInfo: (labelSlug: string) => ({
    CALL_API: {
      type: 'FETCH_LABEL_INFO',
      method: 'GET',
      endpoint: `/api/label/${labelSlug}/`,
      requestKey: labelSlug,
      schema: labelSchema,
    },
  }),
  fetchLabels: (queryString: string, page = 1) => {
    const parsedQueryString = parseQueryForSearch(queryString, page)
    return {
      CALL_API: {
        type: 'FETCH_LABELS',
        method: 'GET',
        endpoint: `/api/label?${parsedQueryString}`,
        requestKey: queryString,
        schema: labelListSchema,
        actionParams: { page, queryString },
      },
    }
  },
}
